import { KeyboardBackspace } from "@mui/icons-material";
import { Box, IconButton, Sheet, Stack, Typography } from "@mui/joy";
import { useNavigate } from "react-router";

const HeaderBackButtonCoin = ({ image, title }) => {
  const navigate = useNavigate();
  return (
    <>
      <Sheet
        sx={{
          display: "flex",
          alignItems: "center",

          position: "sticky",
          top: 0,
          width: "100vw",
          height: "var(--Header-height)",
          zIndex: 9995,
          padding: "10px 10px",
          borderBottom: "1px solid",
          borderColor: "background.level1",
          boxShadow: "sm",
        }}
        variant="outlined"
      >
        <IconButton onClick={() => navigate(-1)} size="lg" variant="plain">
          <KeyboardBackspace fontSize="xl2" />
        </IconButton>
        <Stack ml={2} direction="row" spacing={1} justifyContent="center">
          <img height={25} alt="" src={image} />
          <Typography>{title}</Typography>
        </Stack>
      </Sheet>
      <Box mt={2} />
    </>
  );
};

export default HeaderBackButtonCoin;
